import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { LoadingContext, M_StateActions, NavigateContext } from 'src/M_Components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import AddressConfig from './AddressConfig';
import AddressConfigCrud from './AddressConfigCrud';

export default function AddressPage({ roles, onCreateTab, toastMessages, handleTabClose }) {
    const ctx = useContext(LoadingContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { renameTab } = useContext(NavigateContext);
    const matches = useMediaQuery('(min-width:900px)');
    const M_State = useSelector((state) => state.StateKeyValue);
    const selectedTab = useSelector((s) => s.StateKeyValue.find((o) => o.key === 'selectedTab')?.value);
    const location = useLocation();

    const [menu, setMenu] = useState(1);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const [id, setId] = useState(() => M_State.find((obj) => obj.key === 'selectedTab')?.value || 'addresses');

    //===========================================================================================
    // Functions to manage session storage for each tab
    //===========================================================================================
    const upsertSession = (tabId, kv) => {
        const current = M_State.find((o) => o.key === tabId)?.value || []; // Current array of key-value pairs for the tab
        const filtered = current.filter((e) => e.key !== kv.key); // Remove any existing entry with the same key
        dispatch(M_StateActions.addM_State({ key: tabId, value: [...filtered, kv] })); // Update the state with the new array
    };

    //===============================================================================
    // Function to retrieve session data for a given tab ID
    //===============================================================================
    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true);
        const session = M_State.find((obj) => obj.key === sessionID)?.value; // Get the array of key-value pairs for the tab rfom the state
        if (session) { // If there is session data, restore the state
            const m = session.find((x) => x.key === 'menu')?.value;
            const addr = session.find((x) => x.key === 'selectedAddress')?.value;
            const ref = session.find((x) => x.key === 'refresh')?.value;
            if (m) setMenu(m);
            if (addr) setSelectedAddress(addr);
            if (ref !== undefined) setRefresh(ref);
        }
        ctx.setIsLoad(false);
    };

    //===========================================================================================
    // On mount, set the tab ID and rename the tab to "Addresses"
    //===========================================================================================
    useEffect(() => {
        if (!selectedTab) return;
        renameTab(String(selectedTab), t('Addresses'));
    }, [selectedTab, t]);

    //===========================================================================================
    // Useffect to get session data when the pathname changes
    //===========================================================================================
    useEffect(() => {
        getSessionStorageData(id);
        setRefresh((r) => !r);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    //===========================================================================================
    // Persist session data for the current tab
    //===========================================================================================
    useEffect(() => {
        if (!id) return;
        upsertSession(id, { key: 'menu', value: menu });
        upsertSession(id, { key: 'selectedAddress', value: selectedAddress });
        upsertSession(id, { key: 'refresh', value: refresh });
    }, [id, menu, selectedAddress, refresh]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="divGlobalSettings">
            <div style={matches ? { display: 'flex' } : {}}>
                <div className="settingsPageMainDiv">
                    <Routes>
                        <Route
                            index
                            element={
                                <AddressConfig
                                    roles={roles}
                                    onCreateTab={onCreateTab}
                                    toastMessages={toastMessages}
                                    selectedAddress={selectedAddress}
                                    setSelectedAddress={setSelectedAddress}
                                    refresh={refresh}
                                    setRefresh={setRefresh}
                                />
                            }
                        />
                        <Route
                            path="addressConfigCrud"
                            element={<AddressConfigCrud handleTabClose={handleTabClose} toastMessages={toastMessages} />}
                        />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
